import { get } from 'redux/lib/api';

export const getIntegrations = () => {
  return get('integration', {
    action: 'GET_INTEGRATIONS'
  });
};
